const PANEL_ROLES = ['school_admin', 'teacher', 'counselor'];

/** The panel role for a sign-in or `/api/user-info/` payload, or null when the
 *  account has no panel role. The backend UserProfile.role wins over institution type. */
export function deriveRole(info: any): string | null {
    if (!info) return null;
    if (info.is_superuser || info.role === 'superuser') return 'superuser';
    if (PANEL_ROLES.includes(info.role)) return info.role;
    if (info.school === 'School') return 'school';
    if (info.school === 'University/College') return 'college_university';
    return null;
}
